export const MIN_SEARCH_LENGTH = 5;

export const formatSuggestionLabel = (suggestion) => {
  if (!suggestion) {
    return "";
  }

  if (suggestion.secondary) {
    return `${suggestion.street_line} ${suggestion.secondary}, ${suggestion.city} ${suggestion.state}, ${suggestion.zipcode}`;
  }

  return `${suggestion.street_line}, ${suggestion.city} ${suggestion.state}, ${suggestion.zipcode}`;
};

export const buildRawAddress = (address) => {
  const suiteType = address?.suite_type ?? "";
  const suiteNumber = address?.suite_number ?? "";
  const hasSuiteInfo = Boolean(suiteType || suiteNumber);
  const suiteSuffix = suiteType && suiteNumber ? ` ${suiteNumber}` : suiteNumber ?? "";
  const streetSegment = hasSuiteInfo
    ? `${address.street_number} ${address.route} ${suiteType}${suiteSuffix}`
    : `${address.street_number} ${address.route}`;

  return `${streetSegment}, ${address.city} ${address.state} ${address.post_code}`;
};

export const suggestionToAddressPayload = (suggestion) => {
  if (!suggestion) {
    return null;
  }

  const raw = suggestion.secondary
    ? `${suggestion.street_line} ${suggestion.secondary}, ${suggestion.city} ${suggestion.state}, ${suggestion.zipcode}`
    : `${suggestion.street_line}, ${suggestion.city} ${suggestion.state}, ${suggestion.zipcode}`;

  return {
    raw,
    route: suggestion.secondary ? `${suggestion.street_line} ${suggestion.secondary}` : suggestion.street_line,
    city: suggestion.city,
    state: suggestion.state,
    post_code: suggestion.zipcode,
  };
};
